/* eslint-disable arrow-body-style */
import React from 'react';
import { IconSymbol } from '@abyss/web/ui/IconSymbol';
import {
  copyNodeValue,
  useCyNodeHoverStore,
} from '../../mothership/cyNodeHoverStore';
import { graphNodeHoverApi } from '../../mothership/cyNodeHover';

export const GraphOverlay = () => {
  const { nodeValue, nodeLabel, style, clazz, copied } = useCyNodeHoverStore(
    (state) => state
  );

  const icon = copied ? (
    <IconSymbol icon="check" />
  ) : (
    <IconSymbol icon="content_copy" variant="outlined" />
  );

  const title = copied ? 'Copied to clipboard' : 'Copy node value to clipboard';

  return (
    <div
      id="graph-node-hover-overlay"
      data-testid="graph-node-hover-overlay"
      data-cy="graph-node-hover-overlay"
      style={style}
      className={`${clazz} dfedsTooltip`}
      onMouseEnter={graphNodeHoverApi.mouseEnterOverlay}
      onMouseLeave={graphNodeHoverApi.mouseLeaveOverlay}
      ref={graphNodeHoverApi.setOverlayElement}
      role="tooltip"
      aria-labelledby="graph-node-hover-overlay-label"
    >
      <span id="graph-node-hover-overlay-label">{nodeLabel}</span>
      <span id="graph-node-hover-overlay-value">{nodeValue}</span>
      <button
        id="graph-node-hover-overlay-btn"
        type="button"
        onClick={copyNodeValue}
        title={title}
      >
        {icon}
      </button>
    </div>
  );
};
